// @ts-nocheck
import {
  CFG,
  DEFAULT_BINDS,
  ITEMS,
  ITEM_ORDER,
  KEYBINDS,
  KEY_TO_SLOT,
  REPORT_CATEGORIES,
  REPORT_CAT_ORDER,
  RESERVED_KEYS,
  ROBES,
  SLOT_ORDER,
  SPELLS,
  SPELLS_IN_SLOT,
  SPELL_AVAIL,
  SPELL_ORDER,
  SPELL_SCHOOLS,
  START_LOADOUT,
  UPGRADE,
  eventKeyLabel,
  isLocalDev,
  isTeammate,
  itemCost,
  keyLabelForSlot,
  rebuildKeyToSlot,
  saveKeybinds,
  spellAvail,
  spellInfo,
  spellSfx,
  spellShopDesc,
  spellShopPurchasable,
  teamColor,
} from "../../data";
import {
  TAU,
  bindTabPresenceUnload,
  clamp,
  len,
  lerp,
  rand,
  rgba,
  shade,
  shrinkState,
  tabPresenceId,
  track,
} from "../../util";
import {
  SPRITE_BRIM,
  armTimedProg,
  assetURL,
  bossImageByOct,
  drawArmChargeAccent,
  drawArmRangeTelegraph,
  drawEntityGroundShadow,
  drawSpellSprite,
  drawStar,
  fireballSpriteFXEnabled,
  healPodFromWire,
  makeWizardSprite,
  octIndex,
  pveBossName,
  refreshSpellSpriteDevFields,
  spellCastPopLayer,
  spellCastPopPose,
  spellSpriteAnimFrame,
  spellSpriteDevVisible,
  spellSpriteDrawSz,
  spellSpritePhaseDrawSz,
  spellSpritePhaseLife,
  spellSpritePhaseOpt,
  spellSpritePhaseReady,
  spellSpritePhaseSpec,
  spellSpriteSpec,
  updateSpellSpriteDevPanelVisibility,
  warlockImage,
  warlockImageByOct,
} from "../../sprites";
import {
  AUDIO_CREDITS,
  Sound,
} from "../../audio";
import {
  EMPTY_OPTS,
  Particle,
  Player,
  Sigil,
  compact,
  recalcItems,
} from "../../entities";
import {
  Net,
  Tip,
  angLerp,
  angleDiff,
  escapeHtml,
  fmtWhen,
  modeLabel,
  ordinal,
  setupUiButtonSounds,
  showConfirm,
  spellLabel,
  spellTipHTML,
  tipAttr,
} from "../../net-ui";
import {
  lobbyInviteURL,
  parseLobbyInviteCode,
} from "../../lobby";

import { Game } from "../game-base";
import { updateStatusFxHud } from "../../status-fx";

Game.prototype.loop = function (now) {
    if (this._tabHidden) {
      this._loopActive = false;
      return;
    }
    const frameGap = now - this.last; // ms since previous frame (rAF clock)
    let dt = frameGap / 1000;
    this.last = now;
    // Sample the frame clock once so update + every draw call share a single,
    // frame-coherent timestamp instead of each re-reading performance.now().
    this.now = now;
    this.nowS = now * 0.001;
    dt = Math.min(dt, 0.05);
    const drawStart = performance.now();
    if (dt > 0) this.update(dt);
    this.drawBossIntroCanvas();
    const updEnd = performance.now(); // split logic (update) from paint (render)
    this.tickAlphaPhaseWatch();
    this.syncPreAlphaNotice();
    this.render();
    // Frame-health telemetry: record our own draw cost + the frame gap, then flush
    // a window summary to /clientmetrics while in a live match. Never throws.
    if (this.frameHealth) {
      const end = performance.now();
      const particleCount = this.particles ? this.particles.length : 0;
      this.frameHealth.frame(frameGap, end - drawStart, updEnd - drawStart, end - updEnd, particleCount);
      // Dev-only: perfRecorder is set only on perf.html (separate perf.js bundle).
      if (this.perfRecorder) {
        this.perfRecorder.frame(frameGap, end - drawStart, updEnd - drawStart, end - updEnd, particleCount);
      }
      this.frameHealth.tick(now, this.pingMs || 0, this.state === "playing");
    }
    if (this._loopActive) requestAnimationFrame(this._boundLoop);
  }

Game.prototype.inChromeUI = function () {
    return this.state === "menu" || this.state === "lobby" || this.state === "matchover";
  }

Game.prototype.syncPreAlphaNotice = function () {
    const phase = this.alphaConfig?.phase || "active";
    const showWelcome = this.inChromeUI() && phase === "active";
    if (showWelcome !== this._preAlphaShown) {
      this._preAlphaShown = showWelcome;
      const el = document.getElementById("preAlphaNotice");
      if (el) el.classList.toggle("hidden", !showWelcome);
    }
    const showScheduled = this.inChromeUI() && this.shouldShowAlphaScheduledSplash();
    this.syncAlphaScheduledSplash(showScheduled);
  }

Game.prototype.countdownBeep = function (n) {
    if (n === this._countN) return;
    this._countN = n;
    Sound.countdown(n);
  }

Game.prototype.voidDangerSubject = function () {
    if (this.state !== "playing") return null;
    if (this.inSpectateView()) return this.spectateTarget();
    return this.human();
  }

Game.prototype.playerInVoidRipCore = function (p) {
    const pad = (p.radius || CFG.playerRadius) * 0.5;
    for (const sg of this.sigils) {
      if (sg.spellId !== "voidrip" || sg.arm > 0) continue;
      const r = sg.r || (SPELLS.voidrip && SPELLS.voidrip.radius) || 88;
      const coreR = r * 0.42;
      if (Math.hypot(p.x - sg.x, p.y - sg.y) < coreR + pad) return true;
    }
    return false;
  }

Game.prototype.playerInVoidDanger = function (p) {
    if (!p || !p.alive || p.falling) return false;
    if (p.outside) return true;
    return this.playerInVoidRipCore(p);
  }

Game.prototype.playerLowHpDanger = function (p) {
    if (!p || !p.alive || p.falling) return false;
    const max = p.effMaxHP ? p.effMaxHP() : CFG.maxHP;
    if (max <= 0) return false;
    return p.hp / max < 0.15;
  }

Game.prototype.voidOverlaySubject = function () {
    if (this.state !== "playing" && this.state !== "countdown") return null;
    if (this.inSpectateView()) return this.spectateTarget();
    const p = this.human();
    if (!p || !p.alive || p.falling) return null;
    return p;
  }

Game.prototype.voidOverlayTightness = function (p) {
    const ramp = CFG.voidRampTime || 2.2;
    const t = p.outsideT || 0;
    const raw = clamp(t / (ramp * 2.5), 0, 1);
    return 1 - Math.pow(1 - raw, 1.5);
  }

Game.prototype.tickVoidOverlayTime = function (dt) {
    const p = this.voidOverlaySubject();
    if (!p) return;
    if (p.outside) p.outsideT = (p.outsideT || 0) + dt;
    else p.outsideT = 0;
  }

Game.prototype.voidDangerIntensity = function (p) {
    const max = p.effMaxHP ? p.effMaxHP() : CFG.maxHP;
    return 1 - clamp(p.hp / max, 0, 1);
  }

Game.prototype.tickAudio = function () {
    const manual = this._voidSoundManual;
    if (this.state === "playing") {
      const ph = shrinkState(this.roundTime, this.matchMode).phase;
      if (ph === "shrinking" && this._shrinkPhase !== "shrinking") Sound.alarm();
      this._shrinkPhase = ph;
      const subj = this.voidDangerSubject();
      const active = manual || (subj && this.playerInVoidDanger(subj));
      if (active) {
        const t = subj ? this.voidDangerIntensity(subj) : 0.7;
        Sound.updateVoidIndicator(t);
      } else {
        Sound.stopVoidIndicator();
      }
    } else if (manual) {
      this._shrinkPhase = null;
      Sound.updateVoidIndicator(0.7);
    } else {
      this._shrinkPhase = null;
      Sound.stopVoidIndicator();
    }
  }

Game.prototype.updateBossIntroTimer = function () {
    if (this.state === "bossintro") this.updateBossIntroReadyButton();
  }

Game.prototype.ensureUIEls = function () {
    if (this._uiEls) return;
    this._uiEls = {
      shopTimer: document.getElementById("shopTimer"),
      revealTimer: document.getElementById("revealTimer"),
      draftTimer: document.getElementById("draftTimer"),
      quitBtn: document.getElementById("quitBtn"),
      sandboxCopyLinkBtn: document.getElementById("sandboxCopyLinkBtn"),
      sandboxShopBtn: document.getElementById("sandboxShopBtn"),
      sandboxDraftBtn: document.getElementById("sandboxDraftBtn"),
      sandboxCfg: document.getElementById("sandboxCfg"),
    };
  }

Game.compareActorDepth = function (a, b) {
    return a.y - b.y;
  }

Game.prototype.updateShopTimer = function () {
    const draftOverlay = (this.state === "shop" || this.sandboxDraftOpen) && this.mode === "remote" && this.shopDeadline;
    const left = draftOverlay
      ? Math.max(0, Math.ceil((this.shopDeadline - performance.now()) / 1000)) : null;
    this.ensureUIEls();
    const els = this._uiEls;
    const timers = [
      ["shopTimer", els.shopTimer],
      ["revealTimer", els.revealTimer],
      ["draftTimer", els.draftTimer],
    ];
    for (const [id, el] of timers) {
      if (!el) continue;
      const isDraft = id === "draftTimer" && (this.matchMode === "skilldraft" || this.sandboxDraftOpen);
      if (left !== null) {
        el.textContent = left > 0
          ? (isDraft ? `${left}s to pick` : `Next round in ${left}s`)
          : "Starting…";
        el.style.display = "";
      } else el.style.display = "none";
    }
  }

Game.prototype.updateQuitButton = function () {
    const inLobby = this.state === "lobby" && this.mode === "remote";
    const inMatch = this.state === "bossintro" || this.state === "countdown" || this.state === "playing" ||
                    this.state === "roundover" || this.state === "shop";
    const soloOrSpec = this.spectating || this.roundSpectate || this.humanCount <= 1;
    const inShop = this.state === "shop";
    const sandboxLeave = this.matchMode === "sandbox" && this.state === "playing";
    const inOnlineMatch = this.mode === "remote" || !!this.creds || this._fromMatchmaking;
    const show = sandboxLeave
      || (inShop && inOnlineMatch)
      || (this.mode === "remote" && (inLobby || (inMatch && soloOrSpec)));
    this.ensureUIEls();
    const quitBtn = this._uiEls.quitBtn;
    if (quitBtn) quitBtn.classList.toggle("hidden", !show);
    const copyLinkBtn = this._uiEls.sandboxCopyLinkBtn;
    if (copyLinkBtn) copyLinkBtn.classList.toggle("hidden", !sandboxLeave);
  }

Game.prototype.render = function () {
    const c = this.ctx;
    this.tickAudio();
    this.updateShopTimer();
    this.tickDraftPickCountdown();
    this.updateBossIntroTimer();
    this.tickLobbyStartCountdown();
    this.updateMmReadyCheckTimer();
    this.updateMmFillTimer();
    this.updateMmQueueTimer();
    this.updateAlphaScheduledCountdown();
    this.updateMmQueueCooldownUI();
    this.updateQuitButton();
    this.updateSandboxShopBtn();
    // void background
    c.fillStyle = this.arenaTheme().voidFill;
    c.fillRect(0, 0, this.W, this.H);
    this.drawStars();
    this.drawArenaAmbient?.();
    this.drawVoidAmbient();

    const playing = this.state === "bossintro" || this.state === "playing" || this.state === "countdown" ||
                    this.state === "roundover";
    if (playing && this.players.length) {
      // world space, under the camera (zoom about screen center, camera centered)
      c.save();
      c.translate(this.cx, this.cy);
      c.scale(this.scale, this.scaleY);
      c.translate(-this.camX, -this.camY);
      this.drawPlatform();
      this.drawFloorBurns();
      this.drawBloodStains();
      this.drawPlagueStains();
      this.drawFrostStains();
      this.drawMeteorNukeUmbra();
      this.drawMeteorNukeFuses();
      this.drawArcaneDetonationOrbs();
      this.drawSigils();
      this.drawEssenceWards();
      this.drawEssenceCastFx();
      this.drawTitanFissures();
      this.drawIcePatches();
      this.drawSoakRings();
      this.drawHowlingGaleTelegraph();
      this.drawRiftCollapseField();
      this.drawWindFields();
      this.drawBossBeams();
      this.drawNullSphereErupts();
      this.drawHealPods();
      this.drawArmPops();
      this.drawSpellSpritePops("behind");
      this.drawBlizzards();
      this.drawPoisonPools();
      this.drawHellRips();
      this.drawFireWalls();
      this.drawIceWalls();
      this.drawVoidglass();
      this.drawMines();
      this.drawStickyMines();
      this.drawHookChains();
      this.drawProjectiles();
      this.drawBlizzardRain();
      this.drawParticles();
      this.drawMeteorNukeSwamps();
      this.drawMeteorNukeClouds();
      this.drawBeams();
      this.drawChargeStamps();
      this.drawKaelSpatialSwapTelegraph();
      this.drawBloomRipples();
      this.drawShockwaves();
      this.drawTethers();
      this.drawContagionTether();
      // Actors (stones + wizards + ice walls) painted back-to-front by ground Y so
      // a tall stone occludes a wizard standing behind it (oblique 2.5D depth sort).
      // Ice walls join the sort by their centre so their raised mass overlays players
      // behind them (frozen look) while players in front still occlude the ice.
      {
        const me = this.human();
        const actors = this._actorSortScratch;
        actors.length = 0;
        for (const pl of this.pillars) if (pl.active) actors.push({ y: pl.y, kind: 0, ref: pl });
        for (const t of (this.spriteTrails || [])) actors.push({ y: t.y, kind: 3, ref: t });
        for (const p of this.players) if (p.alive) actors.push({ y: p.y, kind: 1, ref: p });
        for (const w of this.icewalls) actors.push({ y: w.y, kind: 2, ref: w });
        for (const v of (this.voidglass || [])) if (v.ph === 0) actors.push({ y: v.y, kind: 2, ref: v });
        for (const v of (this.voidglass || [])) if (v.ph === 1 || v.ph === 2) actors.push({ y: v.y, kind: 4, ref: v });
        actors.sort(Game.compareActorDepth);
        for (const a of actors) {
          if (a.kind === 0) this.drawPillar(a.ref);
          else if (a.kind === 3) this.drawSpriteTrailGhost(a.ref);
          else if (a.kind === 1) this.drawPlayer(a.ref, me);
          else if (a.kind === 4) this.drawVoidglassBall(a.ref);
          else this.drawIceWallMass(a.ref);
        }
        c.globalAlpha = 1;
      }
      this.drawEssenceSisterLinkBeam();
      this.drawSpellSpritePops("front");
      this.drawDecoys();
      if (this.matchMode === "sandbox" && this.showHitboxes) this.drawHitboxes();
      c.restore();
      // screen space
      this.drawNameplates();
      this.drawDmgPopups();
      this.drawDangerOverlays();
      this.drawHUD();
      this.drawCursorHint();
      if (this.shouldDrawScoreboard()) this.drawScoreboard();
    } else if (this.state === "shop" && !this.spectating) {
      this.drawIdlePlatform();
      this.drawParticles();
      updateStatusFxHud(this);
      const h = this.human();
      if (h) this.drawSpellBar(h, false, true);
    } else {
      this.drawIdlePlatform();
      this.drawParticles();
      updateStatusFxHud(this);
    }
    this.updateScoreboardToggle();
  }
